import { useQuery } from '@tanstack/react-query'
import type { QueryClient } from '@tanstack/react-query'
import { fetchAiSessionCount } from '../api/template-ai-api'
import { templateAiKeys } from './template-ai-keys'

const WAITING_FOR_A_PERSON = 'Ready'

/**
 * The AI drafts waiting for a person (`GET /parse-templates/ai-sessions/count?status=Ready`): the menu pill and the
 * «Borradores de la IA» tab. Read once when the app loads and never polled: the uploads list brings the same number
 * with every load (`writeAiDraftsCount`), and the actions that change it invalidate it. A failed read keeps the last
 * known number and says nothing.
 */
export function useAiDraftsCount(): number | undefined {
  const { data } = useQuery({
    queryKey: templateAiKeys.count(WAITING_FOR_A_PERSON),
    queryFn: async () => (await fetchAiSessionCount(WAITING_FOR_A_PERSON)).count,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    retry: false,
  })
  return data
}

/** The uploads list answers the counter too: it lands in the same cache, so the menu and the tab follow the list. */
export function writeAiDraftsCount(queryClient: QueryClient, count: number): void {
  queryClient.setQueryData(templateAiKeys.count(WAITING_FOR_A_PERSON), count)
}

/** After an action that changes how many drafts wait: publish, discard, retry, assign, a chat turn. */
export function invalidateAiDraftsCount(queryClient: QueryClient): Promise<void> {
  return queryClient.invalidateQueries({ queryKey: templateAiKeys.count(WAITING_FOR_A_PERSON) })
}
